import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNoFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNoFlash"><Path d="M16.5069 14.668L21.6647 19.2527L20.3359 20.7475L2.33594 4.7475L3.66467 3.25269L8.58065 7.62245L13.9984 0.550293V7.5469H21.7198L16.5069 14.668Z" fill="currentColor"/><Path d="M2.22266 15.9219L6.14192 10.8059L14.1339 17.9098L9.99844 23.5591V15.9219H2.22266Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNoFlash;
